import { WidgetsAbstract } from "../widgets/widgets.abstract";

export abstract class CommandAction {
    undo() {
        throw new Error("Function not implemented.");
    }
    redo() {
        throw new Error("Function not implemented.");
    }

    abstract execute(parent: WidgetsAbstract, widget: WidgetsAbstract): WidgetsAbstract;
}
